package one.healthium.today.ui.models

import loco.PERIOD_TRACKER_DAY_FORMAT
import loco.PERIOD_TRACKER_LOG_BUTTON_DEFAULT
import loco.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED
import loco.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE
import loco.PERIOD_TRACKER_PERIOD_LATE_FORMAT
import loco.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT
import loco.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT
import loco.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT
import one.healthium.log_period.domain.PeriodPhase
import one.healthium.loco.LString
import one.healthium.loco.asLString
import androidx.compose.runtime.Immutable

@Immutable
data class PeriodTrackerUiModel(
    val phase: PeriodPhaseUiModel = PeriodPhaseUiModel(),
    val tipText: String? = null,
) {
    fun statusText(): LString? {
        if (phase.phase == PeriodPhase.UNDEFINED) {
            return loco.Res.string.PERIOD_TRACKER_LOG_FIRST_DAY_MESSAGE.asLString()
        }
        val cycleDay = phase.cycleDay ?: return null
        val duration = phase.duration ?: return null
        if (cycleDay - duration > 0) {
            val delay = cycleDay - duration
            return if (delay % 10 == 1) {
                loco.Res.string.PERIOD_TRACKER_PERIOD_LATE_FORMAT.asLString(delay)
            } else {
                loco.Res.string.PERIOD_TRACKER_PERIOD_LATE_PLURAL_FORMAT.asLString(delay)
            }
        } else if (duration - cycleDay <= 5) {
            val ahead = duration - cycleDay
            return if (ahead % 10 == 1) {
                loco.Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_FORMAT.asLString(ahead)
            } else {
                loco.Res.string.PERIOD_TRACKER_PERIOD_PREDICTED_PLURAL_FORMAT.asLString(ahead)
            }
        } else {
            return null
        }
    }

    fun dayText(): LString? {
        if (phase.phase == PeriodPhase.UNDEFINED || statusText() != null) {
            return null
        }
        return phase.cycleDay?.let { loco.Res.string.PERIOD_TRACKER_DAY_FORMAT.asLString(it) }
    }

    fun logButtonText(): LString {
        return when (phase.phase) {
            PeriodPhase.UNDEFINED -> loco.Res.string.PERIOD_TRACKER_LOG_BUTTON_UNDEFINED.asLString()
            else -> loco.Res.string.PERIOD_TRACKER_LOG_BUTTON_DEFAULT.asLString()
        }
    }

}

@Immutable
data class PeriodPhaseUiModel(
    val phase: PeriodPhase = PeriodPhase.UNDEFINED,
    val cycleDay: Int? = null,
    val duration: Int? = null,
)
